import { bffRequest } from "../../shared/api/bff-request";
import {
  ListResponse,
  PaginationRequestParams,
  SortingRequestParams,
} from "../../shared/types/api-types";

import { ChargeSortColumn } from "./constants";
import {
  ChargeItem,
  ChargeListItem,
  GetChargesFilter,
  OutstandingAmountResponse,
} from "./types";

interface GetChargesRequest extends GetChargesFilter {
  pagination: PaginationRequestParams;
  sorting?: SortingRequestParams<ChargeSortColumn>;
}

const createEmptyChargeListResponse = (
  pagination: PaginationRequestParams,
): ListResponse<ChargeListItem> => ({
  list: [],
  pagination: {
    currentPage: pagination.page,
    countPerPage: pagination.countPerPage,
    hasMore: false,
    totalPages: 0,
    totalCount: 0,
  },
});

export const getCharges = async (body: GetChargesRequest) => {
  const response = await bffRequest.post<ListResponse<ChargeListItem> | void>(
    "/charges/list",
    body,
  );

  return response?.pagination
    ? response
    : createEmptyChargeListResponse(body.pagination);
};

export const getCharge = (chargeId: string) =>
  bffRequest.get<ChargeItem>(
    `/charges/item?chargeId=${encodeURIComponent(chargeId)}`,
  );

export const getOutstandingChargeAmount = () =>
  bffRequest.get<OutstandingAmountResponse>("/charges/outstanding-amount");
